import fetch from 'unfetch';

export const refreshPageMixin = {
  data() {
    return {
      currentHash: '{{POST_BUILD_ENTERS_HASH_HERE}}',
      hashChanged: false,
      newHash: '',
      checkUrl: '/version.json'
    }
  },
  created() {
    if (process.env.NODE_ENV != "development") {
      this.initVersionCheck()
    }
  },
  methods: {
    initVersionCheck(frequency = 1000 * 60 * 2) {
      this.checkVersion()
      setInterval(() => {
        this.checkVersion()
      }, frequency)
    },
    async checkVersion() {
      try {
        fetch(this.checkUrl + '?t=' + new Date().getTime())
          .then(r => r.json()) 
          .then(data => {
            this.newHash = data.hash
            this.hashChanged = this.hasHashChanged(this.currentHash, this.newHash);
          })
      } catch (error) {
        this.loading = false;
        if (!error.response) {
          this.errorStatus = 'Error: Network Error'
        } else {
          this.errorStatus = error.response.data.message;
        }
      }
    },
    hasHashChanged(currentHash, newHash) {
      if (!currentHash || currentHash === '{{POST_BUILD_ENTERS_HASH_HERE}}') {
        return true;
      }

      return currentHash !== newHash;
    },
    reloadApp() {
      this.currentHash = this.newHash;
      window.location.reload();
    }
  }
};